import { render, staticRenderFns } from "./AdminPanelAcademic.html?vue&type=template&id=c7b7abfe&scoped=true&external"
import script from "./AdminPanelAcademic.vue?vue&type=script&lang=js"
export * from "./AdminPanelAcademic.vue?vue&type=script&lang=js"
import style0 from "./AdminPanelAcademic.scss?vue&type=style&index=0&id=c7b7abfe&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b7abfe",
  null
  
)

export default component.exports